import { keyframes } from '@mui/material/styles'

const pageEnter = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

/**
 * Fondu d'entrée d'un écran, pour passer du tableau de bord ou des dossiers à une déclaration (et retour)
 * sans saut. Opacité seule : un `transform`, même passager, décrocherait les fenêtres en `position: fixed`
 * de la déclaration. `backwards` : rien ne reste appliqué une fois le fondu fini.
 */
export const pageEnterSx = {
  animation: `${pageEnter} 200ms ease-out backwards`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
} as const

/** Attente d'un écran : rien pendant un chargement éclair, l'indicateur dès qu'il se voit. */
export const pageLoadingSx = {
  animation: `${pageEnter} 200ms ease-out 150ms backwards`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
} as const
